import { createApp } from 'vue';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const mapItems = document.querySelectorAll('.webien-kiruna-map');

mapItems.forEach((mapItem) => {

    let $app = createApp({
        name: "mapItem-" + mapItem.dataset.unique,
        data() {
            return {
                settings: window['widgetSettings_' + mapItem.dataset.unique],
            }
        },
        mixins: [

        ],
        computed: {

        },
        watch: {

        },
        methods: {
            initMap() {

                // If no settings, return
                if(!this.settings || !this.settings.destinations || !this.settings.destinations.length){
                    return;
                }

                mapboxgl.accessToken = 'pk.eyJ1IjoibWlrYWVsYmV2ZW50b3JwIiwiYSI6ImNtaGJ6a3JlaDF1YmIyanBjbWhjaXNucmgifQ.UKTfy-S7brFUFUMX1JQTtA';

                let bounds = new mapboxgl.LngLatBounds();

                // Create initial bound from destinations
                this.settings.destinations.forEach((destination) => {
                    if(destination.lat && destination.lng){
                        bounds.extend([destination.lng, destination.lat]);
                    }
                });


                window['map_' + mapItem.dataset.unique] = new mapboxgl.Map({
                    container: 'map_container_' + mapItem.dataset.unique,
                    config: {
                        basemap: {
                            showPlaceLabels: false,
                            showRoadLabels: false,
                            showTransitLabels: false,
                            showAdminBoundaries: true,
                            showLandmarkIcons: true
                        }
                    },
                    bounds: bounds, // bounding box (southwest corner, northeast corner)
                    // by setting the bounds your map will automatically center around the bounding box
                    fitBoundsOptions: {
                        padding: 20 // padding to keep the bounds away from the edge of the map
                    },
                    //style: 'mapbox://styles/mapbox/outdoors-v12',
                   // maxZoom: 6,
                  //  minZoom: 5,
                });


                // On load zoom bound to level 8
                window['map_' + mapItem.dataset.unique].on('load', () => {
                    // Remove scroll zoom
                    window['map_' + mapItem.dataset.unique].scrollZoom.disable();

                    // Add zoom and rotation controls to the map.
                    window['map_' + mapItem.dataset.unique].addControl(new mapboxgl.NavigationControl());

                    // Change maxZoom
                   // window['map_' + mapItem.dataset.unique].setMaxZoom(10);
                    setTimeout( () => {
                       // window['map_' + mapItem.dataset.unique].setMinZoom(7);
                    }, 1000);

                    window['map_' + mapItem.dataset.unique].fitBounds(bounds, {padding: 20, maxZoom: 8, duration: 1000});

                });





                // Add custom marker for each destination
                this.settings.destinations.forEach((destination) => {

                    // Make sure we have lat/lng first
                    if(!destination.lat || !destination.lng){
                        return;
                    }

                    // create the popup
                    let markerPopup = '<div class="popup">' +
                        '<div class="popup-img"><img src="' + destination.image + '"></div>' +
                        '<div class="popup-close"></div>' +
                        '<div class="popup-descr"><span class="title">' + destination.title + '</span>' + destination.descr + '<a href="' + destination.url + '">Läs mer &rarr;</a></div>' +
                        '</div>';


                    // Create a DOM element for the marker
                    let markerHtml = '<div class="marker-destination">' +
                        '<div class="inner">' +
                        '<div class="title">' + destination.title + '</div>' +
                        '</div>' + markerPopup
                        '</div>';
                    const el = document.createElement('div');
                    el.innerHTML = markerHtml;

                    // Add marker to map
                    const marker = new mapboxgl.Marker(el)
                        .setLngLat([destination.lng, destination.lat])
                        .addTo(window['map_' + mapItem.dataset.unique]);

                    // Detect click on marker and console log
                    el.addEventListener('click', () => {

                        // If only one destination, click
                        if(this.settings.destinations.length === 1){
                            return;
                        }


                        // Remove any other marker active states
                        let activeMarkers = document.querySelectorAll('.mapboxgl-marker.active');
                        activeMarkers.forEach((activeMarker) => {
                            activeMarker.classList.remove('active');
                        });
                        // Add class to marker to show popup
                        el.classList.add('active');

                        // Center map on marker
                        window['map_' + mapItem.dataset.unique].flyTo({
                            center: [destination.lng, destination.lat],
                            speed: 0.5
                        });
                    });

                    // detect click on popup clsose
                    el.querySelector('.popup-close').addEventListener('click', (e) => {
                        e.stopPropagation();
                        el.classList.remove('active');
                    });


                });

            }


        },
        mounted: function () {
            console.log('Settings:', this.settings);
            this.initMap();
        },
        created() {

        },
        components: {
        },
    });

    // Mount app to DOM
    if(document.getElementById('mapItem-' + mapItem.dataset.unique)){
        $app.mount('#mapItem-' + mapItem.dataset.unique);
    }

});